<template>
  <div ref="psContainer" class="e-perfect-scrollbar" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'

  export default {
    name: 'e-perfect-scrollbar',
    props: {
      styles: {
        type: Object,
        default: () => {}
      },
      config: {
        type: Object,
        default: function () {
          return {
            suppressScrollX: true,
            suppressScrollY: false
          }
        }
      },
      // (vue|rxjs)
      emitTypes: {
        type: Array,
        default: function () {
          return []
        }
      },
      updateStreamName: {
        type: String,
        default: null
      },
      eventListeners: {
        type: Array,
        default: function () {
          return ['ps-scroll-y', 'ps-scroll-x']
        }
      },
      // enable/disable that - https://redmine.etton.ru/issues/12435
      useCircularScroll: {
        type: Boolean,
        default: true
      },
      circularScrollStickyDelay: {
        type: Number,
        default: 500
      }
    },
    updated () {
      // TODO: deferred update
      this.update()
    },
    mounted () {
      this.addPerfectScrollbar()
    },
    created () {
      this.lastSettedScrollTop = null
      this.lastScrollEvtTime = {
        y: +new Date(),
        x: +new Date()
      }
    },
    destroyed () {
      // this.ps.destroy()
      this.ps = null
      if (this.subs) {
        this.subs.unsubscribe()
        this.subs = null
      }
    },
    methods: {
      update () {
        if (this.ps) {
          this.ps.update()
        }
      },
      getScrollTop () {
        return this.$refs.psContainer.scrollTop
      },
      setScrollTop (y) {
        this.lastSettedScrollTop = y
        this.$refs.psContainer.scrollTop = y
        // @fix: jumping bottom scroll panel
        this.ps.update()
      },
      setScrollLeft (x) {
        this.$refs.psContainer.scrollLeft = x
        this.ps.update()
      },
      addPerfectScrollbar () {
        this.createPerfectScrollbar()
        this.initEventListeners()
      },
      createPerfectScrollbar () {
        this.ps = new PerfectScrollbar(this.$refs.psContainer, Object.assign({}, this.config))
      },
      reCreatePerfectScrollbar () {
        this.ps.destroy()
        this.ps = null
        this.createPerfectScrollbar()
      },
      initEventListeners () {
        if (this.emitTypes.length > 0) {
          this.eventListeners.forEach(eventType => {
            this.$refs.psContainer.addEventListener(eventType, (e) => {
              this.emit(eventType, e)
            })
          })
        }
        this.$refs.psContainer.addEventListener('wheel', this.circularScroll)
        if (this.updateStreamName) {
          // for drop vue watchers
          let name = JSON.parse(JSON.stringify(this.updateStreamName))
          this.subs = this.$emitter.listen(name, this.onStreamUpdate)
        }
      },
      circularScroll (e) {
        let existVerticalScroll = this.ps.railYHeight !== null && typeof this.ps.railYHeight !== 'undefined'
        // блокировка скрола, если табилца вложена в другую таблицу и обе имеют скрол
        // позволяет избегать прокрочувания родительской табилцы по окончанию прокурчивания дочерней
        if (existVerticalScroll === true) {
          e.preventDefault()
          e.stopPropagation()
        }

        if (this.useCircularScroll !== true) {
          return
        }

        // see https://redmine.etton.ru/issues/12435
        let {deltaY = 0} = e
        let {reach: {y, x}} = this.ps
        let {scrollLeft = 0} = this.$refs.psContainer
        // console.log(y, x, deltaY, existVerticalScroll, this.ps.railYHeight)
        let currentTime = +new Date()
        if (y === null) {
          this.lastScrollEvtTime.y = currentTime
        }
        if (y === null && x != null) {
          this.lastScrollEvtTime.x = currentTime
        }
        if (y === 'end') {
          // vertical end -> horizontal to top
          if (!existVerticalScroll || (existVerticalScroll && deltaY > 0)) {
            if (this.lastScrollEvtTime.y + this.circularScrollStickyDelay < currentTime) {
              this.setScrollLeft(scrollLeft + deltaY)
            }
          }
        } else if (y === 'start' && deltaY < 0) {
          // vertical end -> horizontal to left
          if (this.lastScrollEvtTime.x + this.circularScrollStickyDelay < currentTime) {
            this.setScrollLeft(scrollLeft + deltaY)
          }
        }
      },
      onStreamUpdate (e) {
        if (e && e.action === 'reCreate') {
          this.reCreatePerfectScrollbar()
        } else if (e && e.action === 'scroll') {
          let {x = 0, y = 0} = e.coords
          this.$refs.psContainer.scrollTop = y
          this.$refs.psContainer.scrollLeft = x
          this.ps.update()
        } else {
          this.ps.update()
        }
      },
      emit (type, $event) {
        // ignore last setted positition for prevent
        // loop in event (important for render perfomance in table, table-editable)
        if (this.lastSettedScrollTop !== null) {
          let el = $event.srcElement || $event.target
          if (el.scrollTop === this.lastSettedScrollTop) {
            this.lastSettedScrollTop = null
            // console.warn('scroll event ignored')
            return
          }
          this.lastSettedScrollTop = null
        }
        if (this.emitTypes.indexOf('vue') > -1) {
          this.$emit(type, {
            event: $event,
            ps: this.ps
          })
        }
        if (this.emitTypes.indexOf('rxjs') > -1) {
          this.$emitter.emit('e-perfect-scrollbar', {
            action: type,
            event: $event,
            ps: this.ps
          })
        }
      }
    }
  }
</script>
